<template>
    <div class="transaction-main">
        <div class="main">
            <div class="filter-box">
                <div class="fl">
                    <p class="fl label">订单编号</p>
                    <input class="fl input-box" v-model="orderNum" placeholder="请输入订单编号"/>
                    <p class="fl label">订单状态</p>
                    <select class="input-box fl " v-model="orderStatus">
                        <option value="-1">全部</option>
                        <option value="0">待付款</option>
                        <option value="1">已付款</option>
                        <option value="2">配送中</option>
                        <option value="3">已完成</option>
                    </select>
                </div>
                <div class="fl">
                    <p class="fl label">下单时间</p>
                    <el-date-picker class="fl "
                                    v-model="startTime"
                                    type="date"
                                    size="small"
                                    value-format="timestamp"
                                    placeholder="选择日期">
                    </el-date-picker>
                    <p class="fl">至</p>
                    <el-date-picker class="fl"
                                    v-model="endTime"
                                    type="date"
                                    size="small"
                                    value-format="timestamp"
                                    placeholder="选择日期">
                    </el-date-picker>
                </div>
                <div class="fr button-box">
                    <button class="filter-button resetting fr" @click="reset">重置</button>
                    <button class="filter-button search fr" @click="search">查询</button>
                </div>
                <div class="clear"></div>
            </div>
            <div class="main-body">
                <el-table
                        :data="tableData"
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        stripe
                        style="width: 97%"
                        class="body-table"
                        :row-style="{ height: '46px' }"
                        :header-cell-style="{ textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center' }"
                >
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="blanketOrderNum" label="订单编号"></el-table-column>
                    <el-table-column prop="createTime" label="下单时间">
                        <template slot-scope="scope">
                            {{scope.row.createTime | date}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="payMethod" label="付款方式">
                        <template slot-scope="scope">
                            {{scope.row.payMethod | payType}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="订单金额">
                        <template slot-scope="scope">
                            {{scope.row.amount | price}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="payTime" label="支付时间">
                        <template slot-scope="scope">
                            {{scope.row.payTime | date}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="reciver" label="收货人"></el-table-column>
                    <el-table-column prop="mobile" label="收货电话"></el-table-column>
                    <el-table-column prop="orderStatus" label="订单状态">
                        <template slot-scope="scope">
                            {{scope.row.orderStatus | orderType}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="edit" label="操作">
                        <template slot-scope="scope">
                            <a @click="toToDetail(scope.row.blanketOrderNum)" class="refund pointer">查看订单</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="main-bottom">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        class="fenye"
                        @current-change="current_change"
                >
                </el-pagination>
            </div>
        </div>
        <div class="express-box">
            <div>

            </div>
        </div>
    </div>
</template>

<script>
  import {getAllOrderList} from '@/api/shop'

  export default {
    name: "orderList",
    data() {
      return {
        date: '',
        tableData: [],
        pageSize: 10, //每页的数据条数
        currentPage: 1, //默认开始页面
        istag: true,
        orderNum: '',
        startTime: '',
        endTime: '',
        orderStatus: -1,
        total: 0
      };
    },
    created() {
      this.total = this.tableData.length;
    },
    mounted() {
      this.getOrderList()
    },
    filters:{
      payType(type){
        switch (Number(type)) {
          case 1:
            return '支付宝';
          case 2:
            return '微信';
          case 3:
            return '园区币';
          case 4:
            return '对公转账';
        }
      },
      orderType(type){
        switch (Number(type)) {
          case 0:
            return '待付款';
          case 1:
            return '支付宝';
          case 2:
            return '微信';
          case 3:
            return '园区币';
          case 4:
            return '对公转账';
        }
      }
    },
    methods: {
      toToDetail(orderId) {
        this.$store.state.isTable = false;
        this.$router.push({
          path: '/orderDetail',
          query: {
            orderId: orderId
          }
        })
      },

      search() {
        this.getOrderList()
      },

      reset() {
        this.currentPage = 1;
        this.orderNum = '';
        this.startTime = '';
        this.endTime = '';
        this.getOrderList()
      },

      current_change(currentPage) {
        this.currentPage = currentPage;
        this.getOrderList()
      },

      getOrderList() {
        let postData = {
          length: this.pageSize,
          page: this.currentPage,
          orderStatus: this.orderStatus,
        };
        if(this.orderNum){
          postData.orderNum = this.orderNum;
        }
        if(this.startTime){
          postData.startTime = this.startTime
        }
        if(this.endTime){
          postData.endTime = this.endTime
        }
        getAllOrderList(postData).then(res => {
          const {blanketOrderList, size} = res.data;
          this.tableData = blanketOrderList;
          this.total = size;
        })
      }
    }
  };
</script>

<style scoped lang="scss">
    @import "~@/css/order.scss";
</style>
